import React from 'react';
import { Link } from 'react-router-dom';
import { FaShieldAlt, FaLock } from 'react-icons/fa';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    legal: [
      { path: '/privacy', label: 'Politique de confidentialité' },
      { path: '/cookies', label: 'Politique des cookies' },
      { path: '/terms', label: 'Conditions générales' },
    ],
    info: [
      { path: '/about', label: 'À propos' },
      { path: '/faq', label: 'FAQ' },
      { path: '/comparison', label: 'Comparer' },
    ],
  };

  return (
    <footer className="bg-dark-surface border-t border-dark-border">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <img
                src="/images/logo.webp"
                alt="PariSport France"
                className="h-8 w-auto"
                loading="lazy"
                width="96"
                height="32"
              />
              <span className="text-xl font-bold text-gradient">PariSport France</span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Votre guide de confiance pour les meilleurs bookmakers français. Nous analysons et comparons
              les cotes, bonus et promotions pour vous aider à faire les meilleurs choix.
            </p>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Légal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-yellow-400 transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Information</h3>
            <ul className="space-y-2">
              {footerLinks.info.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-yellow-400 transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-dark-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <div className="flex items-center space-x-2">
                <FaShieldAlt />
                <span>18+ Uniquement</span>
              </div>
              <div className="flex items-center space-x-2">
                <FaLock />
                <span>Sécurisé & Fiable</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              © {currentYear} PariSportFrance.com. Tous droits réservés.
            </p>
            <p className="text-xs text-gray-500">
              Jouez responsablement | ARJEL
            </p>
          </div>
        </div>

        {/* Responsible Gambling Icons */}
        <div className="mt-6 flex flex-wrap justify-center items-center gap-4">
          <a
            href="https://anj.fr/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-70 hover:opacity-100 transition-opacity"
            aria-label="ANJ - Autorité Nationale des Jeux"
          >
            <img
              src="/images/footer/anj.webp"
              alt="ANJ"
              className="h-8"
              loading="lazy"
            />
          </a>
          <a
            href="https://www.hippodromesenfete.fr/jouons-responsable/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-70 hover:opacity-100 transition-opacity"
            aria-label="JOUST - Jouons Responsable"
          >
            <img
              src="/images/footer/jouns.webp"
              alt="JOUST"
              className="h-8"
              loading="lazy"
            />
          </a>
          <a
            href="https://www.data.gouv.fr/en/organizations/autorite-de-regulation-des-jeux-en-ligne-arjel/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-70 hover:opacity-100 transition-opacity"
            aria-label="ARJEL - Autorité de Régulation des Jeux en Ligne"
          >
            <img
              src="/images/footer/arjel.webp"
              alt="ARJEL"
              className="h-8"
              loading="lazy"
            />
          </a>
          <a
            href="https://mediateurdesjeuxenligne.fr/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-70 hover:opacity-100 transition-opacity"
            aria-label="Médiateur des Jeux en Ligne"
          >
            <img
              src="/images/footer/mediater.webp"
              alt="Médiateur"
              className="h-8"
              loading="lazy"
            />
          </a>
          <a
            href="https://www.gambleaware.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-70 hover:opacity-100 transition-opacity"
            aria-label="BeGambleAware"
          >
            <img
              src="/images/footer/begamble.webp"
              alt="BeGambleAware"
              className="h-8"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

